import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Free to Standard Modal (default free edition upgrade modal).
 */
export function isEligibleForFreeToStandardModal(context: EditionAwarenessContextType): boolean {
	const { edition, canUpgrade, canDirectBuyUpgrade, isInCollection, product, currentRoute } =
		context;

	return Boolean(
		isEditionOneOf(edition, ['free']) &&
		(canUpgrade || canDirectBuyUpgrade) &&
		((isProductOneOf(product, ['jira-service-management']) && currentRoute !== 'ops') ||
			// All the other products are eligible for non-collection sites
			(!isInCollection &&
				isProductOneOf(product, ['jira', 'confluence', 'jira-product-discovery']))),
	);
}
